import { Box, Container, Grid, Typography } from "@mui/material"
import { useApiGet, useApiPost } from "auth/useApi2"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { PageTabs } from "components/navigation/PageTabs/PageTabs"
import SubTabs from "components/SubTabs"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoutes } from "generated/routes"
import { companyValidationSchema } from "pages/systemadmin/pages/customers/components/validationSchema"
import { useContext, useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { CompanyForm } from "../../components/CompanyForm"
import { useTranslation } from "react-i18next"

const AddCompany = ({ match }) => {
  const [customerResult, getCustomer] = useApiGet()
  const [addCompanyResult, addCompany] = useApiPost()
  const loadingContext = useContext(GlobalLoaderContext)
  const routerHistory = useHistory()
  const [tabValue, setTabValue] = useState(0)
  const { t } = useTranslation()
  const [tabs, setTabs] = useState([
    { label: t("global.company_information", "Company information") },
    { label: t("global.departments", "Departments") }
  ])

  useEffect(() => {
    getCustomer(apiEndpoints.systemadmincustomers.getcustomerbyid.replace("{id}", match.params.id))
  }, [match, getCustomer])

  useEffect(() => {
    // efter skapa success, redirecta till listan
    if (addCompanyResult.status === 2)
      routerHistory.push(allRoutes.SystemadminCustomersEditCompanies(match.params.id))
  }, [addCompanyResult.status, routerHistory, match])

  useEffect(() => {
    loadingContext.setLoading(() => customerResult.status === 1)
  })

  const handleSubmit = (objectToSave) => {
    addCompany(apiEndpoints.systemadmincustomers.addcompany, objectToSave)
  }

  return (
    <div>
      <PageTabs
        routeBack
        tabs={[
          {
            path: allRoutes.SystemadminCustomersEditCompanies(match.params.id),
            title: t("global.back", "Back")
          }
        ]}
      />
      <Container>
        <Box mb={5}>
          <Grid item container direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h2">{t("settings.form.button.add_company", "Add company")}</Typography>
          </Grid>
        </Box>
        {customerResult.status === 2 ? (
          <>
            <SubTabs tabs={tabs} value={tabValue} setValue={setTabValue} />
            <CompanyForm
              validationSchema={companyValidationSchema(t)}
              customer={customerResult.data}
              onSubmit={handleSubmit}
              tabValue={tabValue}
            />
          </>
        ) : null}
      </Container>
    </div>
  )
}
export default AddCompany
